import { render, staticRenderFns } from "./PrivilegeConfig.vue?vue&type=template&id=fb4acda6&scoped=true"
import script from "./PrivilegeConfig.vue?vue&type=script&lang=js"
export * from "./PrivilegeConfig.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeConfig.vue?vue&type=style&index=0&id=fb4acda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4acda6",
  null
  
)

export default component.exports